module.exports = __webpack_public_path__ + "media/images/flags/32/Trinidad-and-Tobago-e382af22876d5e87bfa577deda0a6eac.png";